import React, { Component } from 'react';
import { BrowserRouter } from 'react-router-dom';
import axios from 'axios';
import { AuthProvider, AuthConsumer } from '../../Utils/AuthContext';

// import '../../../node_modules/ebs-ui-kit/dist/css/ebs-ui-kit.css';
import './App.scss';
// import './Theme.scss';
import 'bootstrap/scss/bootstrap.scss'
import '@fortawesome/fontawesome-free/css/all.css';
import 'react-bootstrap-typeahead/css/Typeahead.css';

import Login from '../Login/Login';
import Logged from '../Logged/Logged';
import { Configurations } from '../../Utils/Configurations';
// import Usuario from '../../Utils/Usuario';
import ScrollToTop from '../../Components/ScrollToTop/ScrollToTop';
// import { Provider } from '../../Context/Context-Menu-Acesso-Rapido/Context-Menu-Acesso-Rapido';

class App extends Component {
  constructor(props) {
    super(props);
    this.registerInterceptors = this.registerInterceptors.bind(this);
    this.setNotLogged = this.setNotLogged.bind(this);
    this.atualizaListaAtendimentosMenu = this.atualizaListaAtendimentosMenu.bind(this);
    this.setIdPedidoAtualizado = this.setIdPedidoAtualizado.bind(this);
    this.toggleMenuAcessoRapido = this.toggleMenuAcessoRapido.bind(this);
    this.toggleAlteracao = this.toggleAlteracao.bind(this);
    this.logout = this.logout.bind(this);
    this.configs = new Configurations();

    this.state = {
      isLogged: false,
      // listaAtendimentosMenu: [],

      // flagAlteracaoAtendimento: false,
      // flagAlteracaoPedido: false,

      // idAtendimentoAtual: null,
      // idPedidoAtual: null,

      // idPedidoAtualizado: null,
      // setIdPedidoAtualizado: (idPedido) => this.setIdPedidoAtualizado(idPedido),

      // toggleAlteracao: this.toggleAlteracao,

      // openMenuAcessoRapido: false,
      // toggleMenuAcessoRapido: this.toggleMenuAcessoRapido,

      // setAtendimentosMenu: this.atualizaListaAtendimentosMenu,
      // getAtendimentosMenu: () => { return this.state.listaAtendimentosMenu },

      // tipoMenu: "atendimento",
      // setTipoMenu: (tipo) => this.setState({ tipoMenu: tipo }),
    };
    this.registerInterceptors();
  }

  atualizaListaAtendimentosMenu(lista, idAtendimentoAlterado) {
    this.setState({ listaAtendimentosMenu: lista }, () => {
      if (idAtendimentoAlterado && (idAtendimentoAlterado === this.state.idAtendimentoAtual)) this.setState({ flagAlteracaoAtendimento: true })
    })
  }

  setIdPedidoAtualizado(idPedido) {
    this.setState({ idPedidoAtualizado: idPedido }, () => {
      const _ped1 = parseInt(this.state.idPedidoAtual, 10),
        _ped2 = parseInt(this.state.idPedidoAtualizado, 10);
      if (_ped1 === _ped2) this.setState({ flagAlteracaoPedido: true })
    });
  }


  toggleMenuAcessoRapido(flag = null, idAtendimento, idPedido, tipo) {
    this.setState({
      openMenuAcessoRapido: flag ? flag : !this.state.openMenuAcessoRapido,
      tipoMenu: tipo,
      idAtendimentoAtual: idAtendimento,
      idPedidoAtual: idPedido
    })
  }

  toggleAlteracao(campo) {
    this.setState({ [campo]: !this.state[campo] })
  }

  registerInterceptors() {
    // const _self = this;
    axios.interceptors.request.use(config => {
      const token = window.localStorage.getItem(this.configs.tokenKey);

      if (token) {
        config.headers['x-access-token'] = token;
      }

      return config;
    }, error => Promise.reject(error));


    axios.interceptors.response.use(config => {
      if (config.data && config.data.token) {
        window.localStorage.setItem(this.configs.tokenKey, config.data.token);
      }

      return config
    }, error => {
      if (error.response && error.response.status === 401) {
        this.logout();
      }
      return Promise.reject(error)
    });
  }

  logout() {
    // Usuario.setLoggedUser = null;
    window.localStorage.removeItem(this.configs.tokenKey);
    this.setState({ isAuth: false });
    window.location.href = "/";
  }

  setNotLogged() {
    // localStorage.clear();
    AuthConsumer.isAuth = false;
    this.setState({ isLogged: false });
  }

  render() {
    return (
      <BrowserRouter>
        <ScrollToTop>

          <AuthProvider>
            <AuthConsumer>
              {({ isAuth, logout }) => (
                <div>

                  {/* <pre style={{
                    zIndex: 9999,
                    position: 'absolute',
                    top: 0
                  }}>{JSON.stringify(isAuth)}</pre> */}
                  {isAuth ? (
                    // <Provider value={this.state}>
                      <Logged logout={logout} />
                    // </Provider>
                  ) : (
                      <Login />
                    )}
                </div>
              )}
            </AuthConsumer>
          </AuthProvider>
        </ScrollToTop>
      </BrowserRouter >
    );
  }
}

export default App;
